export default __webpack_public_path__ + "static/media/netflix.17cbeb7d.webp";